import { Col, Container, Row } from 'react-bootstrap';
import Banner from '../../images/dr-image.png'

import './hero.css'

export default function Hero() {
  return <div >
      <Container className='Container2'>
          <Row className='d-flex justify-content-around align-items-center py-5 marginAlt2'>
              <Col xs='5' sm='6' md='4' lg='3'>
                <div className='textContainer mt-0 mb-5'>
                    <h1>Bienvenido a Toxifinder</h1>
                    <p>
                        Web App desarrollada con el fin de brindar información útil sobre toxicología clínica.
                    </p>
                </div>
              </Col>
              <Col xs='5' md='4'>
                <img className='img' src={Banner} alt="" max-width='100%' height='auto'/>
              </Col>
          </Row>
      </Container>
  </div>;
}


